<div class="main" [ngClass]="{'justify-none':_flowType === 'nbn'}" >
	<span
		*ngIf="_valueType === 'currency'"
		class="symbol"
		[innerHtml]="_symbol"
	></span>
	<span class="value" [innerHtml]="_valueStr"></span>
	<span
		*ngIf="valueSuffix"
		class="value-text"
		[innerHtml]="valueSuffix"
	></span>
</div>
<div *ngIf="__subText" class="sub" [ngClass]="{'align-left':_flowType === 'nbn'}"[innerHtml]="__subText"></div>
<div *ngIf="__discountText" class="discount" [ngClass]="{'align-left':_flowType === 'nbn'}" [innerHtml]="__discountText"></div>
